module.exports = __webpack_public_path__ + "static/media/twitter-square-brands.ba75fe8c.svg";